import { differenceInDays, isAllDayEvent, isSameDay, userDate } from 'owa-datetime';
import {
    formatOneDayAllDayTimeSpan,
    formatMultiDayAllDayTimeSpan,
    formatSingleDayTimeSpan,
    formatSingleDayTimeSpanWithoutDate,
    formatMultiDayTimeSpan,
} from './formatTimeSpan';

export default function formatConflictingTimeSpan(
    start: string,
    end: string,
    showDate: boolean,
    isShortString: boolean = false
): string {
    const startDate = userDate(start);
    const endDate = userDate(end);

    if (isAllDayEvent(startDate, endDate)) {
        if (differenceInDays(startDate, endDate) === -1) {
            return formatOneDayAllDayTimeSpan(startDate, endDate, isShortString);
        } else {
            return formatMultiDayAllDayTimeSpan(startDate, endDate, isShortString);
        }
    } else if (isSameDay(startDate, endDate)) {
        return showDate
            ? formatSingleDayTimeSpan(startDate, endDate, isShortString)
            : formatSingleDayTimeSpanWithoutDate(startDate, endDate);
    } else {
        return formatMultiDayTimeSpan(startDate, endDate, isShortString);
    }
}
